import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlyphsDollarBillWaveBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.6 23.425v-7.25a4.05 4.05 0 0 0 2.111-.331 4.05 4.05 0 0 0 2.36-4.177 36 36 0 0 0 7.738-1.182l4.383-1.17a36 36 0 0 1 7.73-1.182 4.05 4.05 0 0 0 4.478 4.442v7.25a4.05 4.05 0 0 0-4.472 4.508 36 36 0 0 0-7.736 1.182l-4.383 1.17a36 36 0 0 1-7.73 1.182 4.07 4.07 0 0 0-.332-2.07A4.05 4.05 0 0 0 3.6 23.425m16.643-9.178a3.507 3.507 0 0 0-5.647 2.78v1.947a3.507 3.507 0 0 0 7.015 0v-1.948a3.5 3.5 0 0 0-1.368-2.779M8.737 18.549a1.17 1.17 0 0 1 1.882.927v.649a1.17 1.17 0 0 1-2.338 0v-.649a1.17 1.17 0 0 1 .456-.927m18.526-3.6a1.17 1.17 0 0 0-1.882.927v.649a1.169 1.169 0 1 0 2.338 0v-.649a1.17 1.17 0 0 0-.456-.927",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.25,
		d: "M3.6 12.6a.9.9 0 0 1 .9-.9h2.033a36 36 0 0 0 9.276-1.215l4.383-1.17A36 36 0 0 1 29.468 8.1H31.5a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9h-2.032c-3.132 0-6.25.409-9.276 1.215l-4.384 1.17A36 36 0 0 1 6.533 27.9H4.5a.9.9 0 0 1-.9-.9z"
	})]
});
export default SvgGlyphsDollarBillWaveBold;
